export function formatGroupedNumber(value) {
  if (value === '' || value === null || value === undefined) return '';
  const raw = parseGroupedNumber(value);
  const match = raw.match(/^(-?)(\d*)(\.?)(\d*)$/);
  if (!match) return '';
  const [, sign, whole, dot, fraction] = match;
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${sign}${grouped}${dot}${fraction}`;
}

export function parseGroupedNumber(value) {
  return String(value ?? '').replace(/,/g, '').trim();
}

export function sanitizeGroupedDraft(value) {
  const cleaned = parseGroupedNumber(value).replace(/[^\d.]/g, '');
  const [whole, ...fraction] = cleaned.split('.');
  return fraction.length ? `${whole}.${fraction.join('')}` : whole;
}

export function cursorAfterGroupedFormat(formatted, digitsBefore) {
  if (digitsBefore == null) return formatted.length;
  let seen = 0;
  for (let index = 0; index < formatted.length; index += 1) {
    const character = formatted[index];
    if ((character >= '0' && character <= '9') || character === '.') {
      seen += 1;
    }
    if (seen >= digitsBefore) return index + 1;
  }
  return formatted.length;
}
